// extracted by mini-css-extract-plugin
export default {"configRobot":"RobotCalendar_configRobot__+AZV1"};